import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";

export const MobileActionBar = () => (
  <div
    className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-ei-navy/15 bg-ei-navy/95 backdrop-blur-md px-3 py-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] flex gap-2.5"
    data-testid="mobile-action-bar"
  >
    <a
      href="tel:0414662445"
      className="flex-1 inline-flex items-center justify-center gap-2 min-h-[48px] rounded-sm border border-ei-white/30 text-ei-white font-display text-sm font-bold active:scale-[0.98] transition-transform"
      data-testid="mobile-action-call"
    >
      <Phone className="w-4 h-4" /> Call sales
    </a>
    <Link
      to="/request-a-quote"
      className="flex-1 inline-flex items-center justify-center gap-2 min-h-[48px] rounded-sm bg-ei-gold text-ei-navy font-display text-sm font-bold active:scale-[0.98] transition-transform"
      data-testid="mobile-action-quote"
    >
      <FileText className="w-4 h-4" /> Get a quote
    </Link>
  </div>
);

export default MobileActionBar;
